import { Typography } from '@mui/material';
import type { TypographyProps } from '@mui/material';

const DEFAULT_SX = {};

export function TypographyClampLines(props: TypographyClampLinesProps) {
  const { lines = 1, children, sx = DEFAULT_SX, ...typographyRest } = props;

  return (
    <Typography
      sx={{
        // https://css-tricks.com/line-clampin/
        overflow: 'hidden',
        display: '-webkit-box',
        '--clamp-lines': lines,
        WebkitLineClamp: 'var(--clamp-lines, 1)',
        WebkitBoxOrient: 'vertical',
        ...sx,
      }}
      {...typographyRest}
    >
      {children}
    </Typography>
  );
}
export interface TypographyClampLinesProps extends TypographyProps {
  lines: number;
}
